import tags from "../../../components/tags";
import { icons } from "../../../components/html";
import { statusCodes } from "../../../components/responses";

export default {
  "/client/people": {
    get: {
      tags: [tags.businessAccount],
      summary: "List of connected users",
      description: `${icons.c}
      Returns list of connected users, which match selected filtration. Connected user means a user authorized by the client (eg: e-shop) to access data in his user profiles.`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/userEmailFilter" },
        { $ref: "#/components/parameters/gender" },
        { $ref: "#/components/parameters/limit" },
        { $ref: "#/components/parameters/offset" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  user: {
                    $ref: "#/components/schemas/user"
                  },
                  filled_measures: {
                    $ref: "#/components/schemas/measure"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
